module.exports = __webpack_public_path__ + "media/images/report_areas/hudson-seal-68da60ead2f364f8ffba03b03efca75d.jpg";